import { Component, OnInit, Input, ViewChild, AfterViewInit } from '@angular/core';

import { ScrollPanel } from 'primeng/primeng';
import { HostComponent } from '../host/host.component';
import { PreAuthenticationResponse } from '@picard/models-lib';
import { StorageConstants } from '@picard/shared-lib';

@Component({
  selector: 'app-menu',
  templateUrl: './menu.component.html',
  styleUrls: ['./menu.component.css']
})
export class MenuComponent implements OnInit, AfterViewInit {
  //#region Properties
  @Input() reset: boolean;
  model: any[];
  preAuthenticationResponse: PreAuthenticationResponse;
  @ViewChild('scrollPanel') layoutMenuScrollerViewChild: ScrollPanel;
  //#endregion Properties

  //#region Constructor
  constructor(public hostComponent: HostComponent) {}
  //#endregion Constructor

  //#region Functions
  ngAfterViewInit() {
    setTimeout(() => {
      this.layoutMenuScrollerViewChild.moveBar();
    }, 100);
  }
  ngOnInit() {
    this.preAuthenticationResponse = JSON.parse(sessionStorage.getItem(StorageConstants.preAuth));

    this.model = this.preAuthenticationResponse.menuObjectItemModelCollection;
    //this.model = JSON.parse('[{"label":"Dashboard","icon":"dashboard","routerLink":["/dashboard"]},{"label":"Loyalty History","icon":"hourglass_full","routerLink":["/history"]},{"label":"Voucher History","icon":"voucher_coupon","routerLink":["/vouchers"]},{"label":"Profile","icon":"face","routerLink":["/profile"]},{"label":"Locations","icon":"room","routerLink":["/locations"]},{"label":"Terms & Conditions","icon":"file","routerLink":["/terms"]}]');
  }
  changeTheme(theme) {
    const themeLink: HTMLLinkElement = <HTMLLinkElement>document.getElementById('theme-css');
    themeLink.href = 'assets/theme/theme-' + theme + '.css';
  }
  changeLayout(theme) {
    const layoutLink: HTMLLinkElement = <HTMLLinkElement>document.getElementById('layout-css');
    layoutLink.href = 'assets/layout/css/layout-' + theme + '.css';
  }
  //#endregion Functions
}
